import axios from "axios";
import { getHeaders, getURl } from "./core";

let url = `${getURl()}/pdd/v1`;

export function getAppraisals({ offset = 0, limit = 15, search = "", year = 0 }) {
   const result = axios({
      method: "GET",
      headers: getHeaders(),
      url: `${url}/appraisals?offset=${offset}&limit=${limit}&search=${search}&year=${year}`,
   });
   return new Promise((resolve, reject) => {
      result
         .then((response) => resolve(response.data))
         .catch((error) => reject(error));
   });
}

export function getAppraisalById(id) {
   const result = axios({
      method: "GET",
      headers: getHeaders(),
      url: `${url}/appraisals/${id}`
   });
   return new Promise((resolve, reject) => {
      result
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
   });
}

export function createNewAppraisal(data) {
   return axios({
      method: "POST",
      headers: getHeaders(),
      url: `${url}/appraisals`,
      data
   })
}

export function updateAppraisalById(id, data) {
   return axios({
      method: "PUT",
      headers: getHeaders(),
      url: `${url}/appraisals/${id}`,
      data
   })
}

export function submitAppraisal(id, data) {
   return axios({
      method: "PUT",
      headers: getHeaders(),
      url: `${url}/submit_appraisals/${id}`,
      data,
   })
}

export function approveAppraisal(id, data) {
   return axios({
      method: "PUT",
      headers: getHeaders(),
      url: `${url}/approve_appraisals/${id}`,
      data
   })
}